export const getUserDomain = (email?: string) => {
	if (!email) {
		return undefined;
	}

	const emailParts = email.split('@');
	if (emailParts.length === 2 && emailParts[1]) {
		return emailParts[1];
	}
	return undefined;
};
